<template>
  <!-- 最顶部title -->
  <div class="liu pos-manage businesser">
    <mt-header fixed :title="title" class="title2">
      <mt-button slot="left" icon="back" @click="onBackBtnClick">返回</mt-button>
      <mt-button slot="right" @click="visible.search=true">更多</mt-button>
    </mt-header>
    <!-- 页面主体 -->
    <div class="scroll-container" :style="customScrollHeight" v-infinite-scroll="getMoreMyData" :infinite-scroll-disabled="myData.scrollDisabled" infinite-scroll-distance="0">
      <!-- 空页 -->
      <div v-if="isShowEmptyData" />
      <!-- 无数据占位图 -->
      <div v-if="isShowNoData">
        <div class="no-data">
          <img src="../../assets/bitmap_agent@3x.png" width="60%" />
          <div class="title-4">
            {{ emptyStartDate + " - " + emptyEndDate + " 暂无新增业务员" }}
          </div>
          <div class="title-4"> 点击右上角 <span @click="visible.search=true">更多</span> 查看更多业务员信息 </div>
        </div>
      </div>
      <!-- 列表 -->
      <div class="form bn-list mt-15" v-if="isShowListData">
        <div class="bn-row" v-for="(item, index) in myData.list" :key="index" @click="onListRowClick(item)">
          <div class="row-info">
            <div>
              <span class="info-name">{{item.name}}</span><span class="info-type">{{item.typeName}}</span>
            </div>
            <div>
              <span class="info-date">{{item.insertDate}}</span>
            </div>
          </div>
          <div class="row-no">
            <span class="no-text">业务员编号 {{item.userNum}}</span>
          </div>
          <div class="row-no no-padding-b" v-show="item.managerNum">
            <span class="no-text">区域经理编号 {{item.managerNum}}</span>
          </div>
        </div>
      </div>
      <!-- 右下角圆形新增按钮 -->
      <div class="invite-box" @click="onAddBusinesserClick">
        新增<br />业务员
      </div>
    </div>
    <!-- 筛选页内容 -->
    <mt-popup class="agent-popup" v-model="visible.search" position="right" :modal="false">
      <div class="agent-content">
        <!-- 标题 -->
        <mt-header fixed title="筛选" class="title2"></mt-header>
        <!-- 内容 -->
        <div class="popup-content">
          <!-- 业务员名称 -->
          <div class="content-box">
            <div>
              <span>业务员名称或编号</span>
            </div>
            <div>
              <input type="text" class="name-mobile w56" v-model="myParam.nameOrUserNum" placeholder="请输入业务员名称或编号" />
            </div>
          </div>
          <!-- 注册时间 -->
          <div class="content-box">
            <div>
              <span>入职时间</span>
            </div>
            <div class="no-border">
              <span class="date" @click="onSearchDateClick('startDate')">{{picker.startDateText}}</span>
              -
              <span class="date" @click="onSearchDateClick('endDate')">{{picker.endDateText}}</span>
            </div>
          </div>
        </div>
        <!-- 按钮 -->
        <div class="more-button">
          <span class="white" @click="onSearchBtnCancelClick">取消</span>
          <span class="blue" @click="onSearchBtnSubmitClick">确定</span>
        </div>
      </div>
    </mt-popup>
    <!-- 日期选择控件 -->
    <mt-datetime-picker ref="datePicker" type="date" :value="picker.selectedDate" :startDate="picker.startDate" :endDate="picker.endDate" year-format="{value} 年" month-format="{value} 月" date-format="{value} 日" @confirm="onDatePickerConfirm" />
  </div>
</template>

<script>
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { CusToast, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { formatDate } from '@/utils/utils';
import { GetXHZSSalesmanList } from '@/api/customer';

export default {
  name: 'BusinesserList',
  data() {
    return {
      title: '业务员管理',
      // 列表数据模型
      myData: {
        list: [
          {
            name: '张晓雅',
            type: '普通业务员',
            date: '2017-09-16 20:58',
            no1: '47388899020',
            no2: '4738889902012',
            tName: '沈晓棠',
          },
          {
            name: '赵小熙',
            type: '普通业务员',
            date: '2017-09-15 20:58',
            no1: '47388899020',
            no2: '',
            tName: '',
          },
          {
            name: '沈晓棠',
            type: '区域经理',
            date: '2017-09-14 20:58',
            no1: '4738889902012',
            no2: '',
            tName: '',
          },
        ],
        total: 2,
        scrollDisabled: true,
      },
      // 查询条件模型
      myParam: {
        endDate: '',
        nameOrUserNum: '',
        pageNum: 1,
        pageSize: 12,
        startDate: '',
        type: 0,
      },
      // 日期组件模型
      picker: {
        startDateBase: '',
        endDateBase: '',
        startDateText: '',
        endDateText: '',
        startDate: new Date(),
        endDate: new Date(),
        selectedDate: null,
        dateType: '',
      },
      // 显示开关模型
      visible: {
        search: false,
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initData();
    });
  },
  computed: {
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
    emptyStartDate() {
      return this.picker.startDateText.replace(/\-/g, '.');
    },
    emptyEndDate() {
      return this.picker.endDateText.replace(/\-/g, '.');
    },
    isShowNoData() {
      return this.myData.total === 0;
    },
    isShowEmptyData() {
      return this.myData.total === -1;
    },
    isShowListData() {
      return this.myData.total > 0;
    },
  },
  methods: {
    // 加载数据
    initData() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 列表清空
      this.myData.list = [];
      // 页数置1
      this.myParam.pageNum = 1;
      // 加载数据
      this.getDateBase(() => {
        this.getMyData();
      });
    },
    // 通过接口获取数据
    getMyData(callback = null) {
      CusLoadingOpen();
      // 先设置禁止滚动加载数据
      this.myData.scrollDisabled = true;
      this.myParam.startDate = `${this.picker.startDateText} 00:00:00`;
      this.myParam.endDate = `${this.picker.endDateText} 23:59:59`;
      GetXHZSSalesmanList(this.myParam)
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.myData.total = res.total;
              this.myData.list.push(...res.rows);
              // 通过记录条数list.length和数据总数total判断是否查询出所有数据
              // 如果记录条数小于数据总数，则证明没有查询出所有数据，设置允许滚动加载数据
              if (this.myData.list.length < this.myData.total) {
                this.myData.scrollDisabled = false;
              }
              callback && callback();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 自动加载获取更多数据
    getMoreMyData() {
      // 通过记录条数list.length和数据总数total判断是否查询出所有数据
      // 如果记录条数小于数据总数，则证明没有查询出所有数据
      if (this.myData.list.length && this.myData.list.length < this.myData.total) {
        this.myParam.pageNum += 1;
        this.getMyData();
      }
    },
    // 代理商列表日期查询条件
    getDateBase(callback) {
      this.picker.startDateBase = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
      this.picker.endDateBase = new Date();
      this.picker.startDateText = formatDate(this.picker.startDateBase);
      this.picker.endDateText = formatDate(this.picker.endDateBase);
      callback && callback();
    },
    // 返回单击事件
    onBackBtnClick() {
      window.location.href = 'protocol://android';
    },
    // 列表行点击事件
    onListRowClick(item) {
      this.$router.push({ path: '/businessermanage/businesserdetail', query: { id: item.salesmanId } });
    },
    // 查询-日期框单击事件
    onSearchDateClick(val) {
      // 设置日期类型
      this.picker.dateType = val;
      // 根据选择的日期类型判断
      switch (val) {
        // 开始日期
        case 'startDate':
          // 日期框显示的最大日期：2000-01-01
          this.picker.startDate = new Date('2000-01-01');
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          // 日期框显示的选中日期：默认查询开始日期
          this.picker.selectedDate = new Date(this.picker.startDateText);
          break;
        // 结束日期
        case 'endDate':
          // 日期框显示的最大日期：默认查询开始日期
          this.picker.startDate = new Date(this.picker.startDateText);
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          // 日期框显示的选中日期：默认查询结束日期
          this.picker.selectedDate = new Date(this.picker.endDateText);
          break;
      }
      this.$refs.datePicker.open();
    },
    // 查询-取消按钮单击事件
    onSearchBtnCancelClick() {
      this.visible.search = false;
    },
    // 查询-确定按钮单击事件
    onSearchBtnSubmitClick() {
      // 1.滚动条置顶
      window.scrollTo(0, 0);
      // 2.关闭查询窗口
      this.visible.search = false;
      // 3.打开滚动刷新
      this.myData.scrollDisabled = true;
      // 4.重置列表数据
      this.myData.list = [];
      // 5.重置翻页页数
      this.myParam.pageNum = 1;
      // 6.重置总数
      this.myData.total = -1;
      // 7. 加载数据
      this.getMyData();
    },
    // 日期控件-确定事件
    onDatePickerConfirm(val) {
      // 根据选择的日期类型判断
      switch (this.picker.dateType) {
        // 开始日期
        case 'startDate':
          // 如果开始日期选择了一个大于当前查询结束日期
          if (val > new Date(this.picker.endDateText)) {
            // 则将查询结束日期自动置为今天的日期
            this.picker.endDateText = formatDate(new Date());
          }
          this.picker.startDateText = formatDate(val);
          break;
        // 结束日期
        case 'endDate':
          this.picker.endDateText = formatDate(val);
          break;
      }
    },
    // adf
    onAddBusinesserClick() {
      this.$router.push({ path: '/businessermanage/businesseradd' });
    },
  },
};
</script>
